import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postTenantLanguage = (token, TenantID, LanguageID) => {
    return fetch(`${apiUrl}tenant_languages`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            TenantID,
            LanguageID
        })
    });
}

export default postTenantLanguage